(function() {
  'use strict';

  // Read config
  var configEl = document.getElementById('nlbvp-config');
  var mountEl = document.getElementById('nlbvp-mount');
  if (!configEl || !mountEl) return;

  var configs;
  try {
    configs = JSON.parse(configEl.textContent);
  } catch(e) {
    console.error('NLBVP: invalid config JSON', e);
    return;
  }

  if (!Array.isArray(configs) || configs.length === 0) return;

  // Find config matching current product
  var currentHandle = mountEl.getAttribute('data-product-handle');
  if (!currentHandle) return;

  var activeConfig = null;
  for (var i = 0; i < configs.length; i++) {
    if (configs[i].productHandle === currentHandle) {
      activeConfig = configs[i];
      break;
    }
  }
  if (!activeConfig || !activeConfig.variants || activeConfig.variants.length === 0) return;

  // Wait for Shopify product data to be available
  function getShopifyProductData(callback) {
    fetch('/products/' + currentHandle + '.js')
      .then(function(r) { return r.json(); })
      .then(callback)
      .catch(function(err) {
        console.error('NLBVP: failed to fetch product data', err);
      });
  }

  // SVG checkmark
  var CHECK_SVG = '<svg class="nlbvp-included-check" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="12" r="11" fill="#22C55E"/><path d="M7 12.5L10.5 16L17 9" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  // Format money in cents to display string ($XX.XX)
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  // Build the picker HTML
  function buildPicker(config, shopifyProduct) {
    // Map Shopify variants by ID for quick lookup
    var variantMap = {};
    shopifyProduct.variants.forEach(function(v) {
      variantMap[v.id] = v;
    });

    // Determine which variant should be selected by default
    // Use the first available variant from Shopify, or fall back to first config variant
    var defaultVariantId = shopifyProduct.variants[0] ? shopifyProduct.variants[0].id : config.variants[0].variantId;

    // Try to read variant from URL (?variant=...)
    var urlParams = new URLSearchParams(window.location.search);
    var urlVariant = urlParams.get('variant');
    if (urlVariant && variantMap[parseInt(urlVariant, 10)]) {
      defaultVariantId = parseInt(urlVariant, 10);
    }

    var html = '<div class="nlbvp-wrapper">';
    html += '<h3 class="nlbvp-heading">' + (config.heading || 'Select an option:') + '</h3>';
    html += '<ul class="nlbvp-grid">';

    config.variants.forEach(function(variant) {
      var shopifyVariant = variantMap[variant.variantId];
      if (!shopifyVariant) {
        console.warn('NLBVP: variant ' + variant.variantId + ' not found in Shopify product');
        return;
      }

      var isSelected = variant.variantId === defaultVariantId;
      var salePrice = formatMoney(shopifyVariant.price);
      var comparePrice = shopifyVariant.compare_at_price && shopifyVariant.compare_at_price > shopifyVariant.price
        ? formatMoney(shopifyVariant.compare_at_price)
        : null;

      html += '<li class="nlbvp-card' + (isSelected ? ' nlbvp-selected' : '') + '" data-variant-id="' + variant.variantId + '">';

      // Top badge (MOST POPULAR / BEST VALUE)
      if (variant.topBadge) {
        var badgeClass = 'nlbvp-badge-' + (variant.topBadgeStyle || 'gold');
        html += '<span class="nlbvp-top-badge ' + badgeClass + '">' + variant.topBadge + '</span>';
      }

      // Image
      html += '<div class="nlbvp-image" style="background-image:url(' + variant.imageUrl + ')"></div>';

      // Name
      html += '<p class="nlbvp-name">' + variant.displayName + '</p>';

      // Price row
      html += '<div class="nlbvp-price-row">';
      html += '<span class="nlbvp-price-sale">' + salePrice + '</span>';
      if (comparePrice) {
        html += '<span class="nlbvp-price-compare">' + comparePrice + '</span>';
      }
      html += '</div>';

      // Discount badge
      if (variant.discountPercent) {
        html += '<span class="nlbvp-discount-badge">' + variant.discountPercent + '% OFF</span>';
      }

      html += '</li>';
    });

    html += '</ul>';

    // What's Included section
    html += '<div class="nlbvp-included">';
    html += '<div class="nlbvp-included-heading">What\'s Included:</div>';
    html += '<ul class="nlbvp-included-list" id="nlbvp-included-list"></ul>';
    html += '</div>';

    html += '</div>';

    return { html: html, defaultVariantId: defaultVariantId };
  }

  // Build the "What's Included" list for a specific variant
  function renderIncludedList(variant) {
    var listEl = document.getElementById('nlbvp-included-list');
    if (!listEl || !variant.included) return;

    listEl.innerHTML = '';
    variant.included.forEach(function(item) {
      var li = document.createElement('li');
      li.className = 'nlbvp-included-item';
      li.innerHTML = CHECK_SVG;

      var span = document.createElement('span');
      if (item.free) {
        span.innerHTML = '<span class="nlbvp-included-free">FREE</span> ' + item.text;
      } else {
        span.textContent = item.text;
      }
      li.appendChild(span);

      listEl.appendChild(li);
    });
  }

// Update Shopify's hidden variant selector and trigger Avenue's variant switch
  function selectVariant(variantId, shopifyProduct) {
    var select = document.querySelector('select[name="id"]');
    if (select) {
      select.value = variantId;
    }

    // Find the full variant object
    var variant = shopifyProduct.variants.find(function(v) { return v.id === variantId; });
    if (!variant) return;

    // Dispatch Avenue's custom event so the price, gallery, ATC button, etc. update
    var event = new CustomEvent('product-variant-switch', {
      bubbles: true,
      detail: { variant: variant }
    });
    document.dispatchEvent(event);

    // Also dispatch native change on the select as a fallback
    if (select) {
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }

    // Update URL to reflect current variant (so refresh keeps selection)
    if (window.history && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variantId);
      window.history.replaceState({}, '', url);
    }
  }

  // Handle card click
 function handleCardClick(card, config, shopifyProduct) {
    var variantId = parseInt(card.getAttribute('data-variant-id'), 10);
    if (!variantId) return;

    var allCards = document.querySelectorAll('.nlbvp-card');
    allCards.forEach(function(c) { c.classList.remove('nlbvp-selected'); });
    card.classList.add('nlbvp-selected');

    selectVariant(variantId, shopifyProduct);

    var configVariant = config.variants.find(function(v) { return v.variantId === variantId; });
    if (configVariant) {
      renderIncludedList(configVariant);
    }
  }

  // Sync picker selection when variant changes externally (from gallery, etc.)
  function watchExternalVariantChanges(config) {
    var select = document.querySelector('select[name="id"]');
    if (!select) return;

    var lastVariantId = parseInt(select.value, 10);

    setInterval(function() {
      var currentVariantId = parseInt(select.value, 10);
      if (currentVariantId === lastVariantId) return;
      lastVariantId = currentVariantId;

      // Update visual selected state
      var allCards = document.querySelectorAll('.nlbvp-card');
      allCards.forEach(function(c) {
        if (parseInt(c.getAttribute('data-variant-id'), 10) === currentVariantId) {
          c.classList.add('nlbvp-selected');
        } else {
          c.classList.remove('nlbvp-selected');
        }
      });

      // Update "What's Included"
      var configVariant = config.variants.find(function(v) { return v.variantId === currentVariantId; });
      if (configVariant) {
        renderIncludedList(configVariant);
      }
    }, 300);
  }

  // Initialize
  function init() {
    getShopifyProductData(function(shopifyProduct) {
      var result = buildPicker(activeConfig, shopifyProduct);
      mountEl.innerHTML = result.html;

      // Wire up clicks
      var cards = mountEl.querySelectorAll('.nlbvp-card');
      cards.forEach(function(card) {
        card.addEventListener('click', function() {
          handleCardClick(card, activeConfig, shopifyProduct);
        });
      });

      // Render initial "What's Included"
      var defaultVariant = activeConfig.variants.find(function(v) { return v.variantId === result.defaultVariantId; });
      if (defaultVariant) {
        renderIncludedList(defaultVariant);
      }

      // Watch for external variant changes (gallery clicks, etc.)
      watchExternalVariantChanges(activeConfig);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();